import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as pullRequests from '../../../../pull-requests'
import * as result from '../result'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: result.RESOURCE.payload.dimension.partialId,
      partialId: result.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The implementation pull request this result belongs to. There is one result per pull request.',
    isOptional: false,
    name: 'Pull Request',
    partialId: PartialId.Standard.create('pull_request'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        pullRequests.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
